"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadDropZone = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _Button = require("../../Button");
var _Uploader = require("../Uploader.labels");
var _jsxRuntime = require("react/jsx-runtime");
var UploadDropZone = /*#__PURE__*/(0, _react.forwardRef)(function (props, fileInputRef) {
  var children = props.children,
    errorMessage = props.errorMessage,
    messagesGender = props.messagesGender,
    _props$maxFileSizeMB = props.maxFileSizeMB,
    maxFileSizeMB = _props$maxFileSizeMB === void 0 ? 3 : _props$maxFileSizeMB,
    onFileChange = props.onFileChange,
    onDragOver = props.onDragOver,
    onDragLeave = props.onDragLeave,
    onDrop = props.onDrop,
    inputAcceptanceTypes = props.inputAcceptanceTypes,
    styles = props.styles;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Uploader.labels
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Uploader__drop'],
    onDragOver: onDragOver,
    onDrop: onDrop,
    onDragLeave: onDragLeave,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      "date-testid": "file",
      ref: fileInputRef,
      type: "file",
      className: styles['cc-Uploader__hidden-input'],
      accept: inputAcceptanceTypes,
      onChange: onFileChange,
      onDrop: onDragLeave,
      "aria-label": getLabel('upload_file')
    }), children ? children : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Uploader__drop-zone'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Uploader__title'],
        children: getLabel("upload_drag_here_".concat(messagesGender))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Uploader__or'],
        children: getLabel('or')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccUploadDropButton",
        view: "outlined",
        color: "primary",
        size: "medium",
        onClick: function onClick() {},
        children: getLabel("upload_choose_file_".concat(messagesGender))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-Uploader__limits'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: getLabel('uploader_size_limits')
        }), " ", /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [maxFileSizeMB, "MB"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Uploader__limits__second'],
          children: getLabel('uploader_type_limits')
        }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: inputAcceptanceTypes
        })]
      }), errorMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Uploader__error'],
        children: errorMessage
      })]
    })]
  });
});
exports.UploadDropZone = UploadDropZone;